import React, { FC } from "react"

import { Avatar, Tooltip } from "@mantine/core"
import data from "./data"
import { Module } from "../../../../contexts/devices-context"
import { IconComponents } from "@tabler/icons-react"
import { useLanguage } from "../../../../contexts/language-context"

type ModulesSummaryProps = {
    modules: Module[]
    limit?: number
}

const ModulesSummary: FC<ModulesSummaryProps> = ({ modules, limit = 3 }) => {
    const { L } = useLanguage()

    return (
        <Avatar.Group spacing="sm">
            {modules
                .sort((m1, m2) => m2.attributes.length - m1.attributes.length)
                .slice(0, limit)
                .map(module => {
                    const Icon = module.name in data ? data[module.name as keyof typeof data].icon : null
                    return (
                        <Tooltip
                            label={
                                module.name in data ? data[module.name as keyof typeof data].getLabel(L) : module.name
                            }
                            key={module.name}
                        >
                            <Avatar radius="xl" color="gold">
                                {Icon ? <Icon size={24} stroke={1.5} /> : <IconComponents size={24} stroke={1.5} />}
                            </Avatar>
                        </Tooltip>
                    )
                })}
            {modules.length - limit > 0 && <Avatar radius="xl">+{modules.length - limit}</Avatar>}
        </Avatar.Group>
    )
}

export default ModulesSummary
